import React, { PureComponent } from 'react';
import Select from 'react-select';
import intl from 'react-intl-universal';

let formatOptions = [
  { value: '', label: 'Original' },
  { value: 'jpeg', label: 'JPG' },
  { value: 'png', label: 'PNG' }
];

export default class ImageFormatChanger extends PureComponent {
  
  onChangeSelect = (key) => ({ value }) => this.props.onOptionChange({[key]: value });

  getProps() {
    const result = {};

    if (formatOptions.map(({ value }) => value).indexOf(this.props.format) < 0) {
      result.format = formatOptions[0].value;
    }

    return { ...this.props, ...result };
  }

  render() {
    const {format} = this.getProps();
    
    formatOptions = [
      { value: '', label: intl.get('Original') },
      { value: 'jpeg', label: 'JPG' },
      { value: 'png', label: 'PNG' }
    ];
    return (
      <div>
        <div>
          <div className="twoSections">
            <div className='section'>
                {intl.get('Format')}
              <Select
              name='format'
              value={format}
              options={formatOptions}
              onChange={this.onChangeSelect('format')}
              clearable={false}
              />
            </div>
            <div className='section'>
              &nbsp; 
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ImageFormatChanger/index.jsx